module.exports = __webpack_public_path__ + "img/list.1eb073c3.svg";